// bulk_edit.js
const ready = function () {
  $(".btn-ajax").on("click", function (e) {
    return $(this).button("loading");
  });
};

$(document).ready(ready);
$(document).on("page:load", ready);
